import React, { useState } from 'react';
import { motion } from "framer-motion";
import TailwindSelect from './Tailwind/TailwindSelect';

let easing = [0.6, -0.05, 0.01, 0.99];
    const animate = {
        opacity: 1,
        y: 0,
        transition: {
        duration: 0.6,
        ease: easing,
        delay: 0.16,
        },
    };

const RecursiveTopicSelector = ({ topics, level, setSelectedTopic, selectedTopic, setDisplayError, reset }) => {
    const [currentTopic, setCurrentTopic] = useState(null);

    const handleTopicChange = (event) => {
        setDisplayError({
            message: '',
            variant: ''
        })
        let newSelectedTopic = selectedTopic ? selectedTopic.topics.slice(0, level) : []
        if (level == 0) {
            setSelectedTopic(prevState => {
                return {
                    ...prevState,
                    modelId: '',
                    description: '', 
                };
            })
        }
        newSelectedTopic.push(event.target.value)
        setSelectedTopic(prevState => {
            return {
                ...prevState,
                topics: newSelectedTopic,
            };
        })
        setCurrentTopic(topics.find(topic => topic.name === event.target.value))
    };

    const handleTopicDescription = (event) => {
        setDisplayError({
            message: '',
            variant: ''
        })
        setSelectedTopic(prevState => {
            return {
                ...prevState,
                description: event.target.value,
            };
        })
    };

    const handleModelChange = (event) => {
        setDisplayError({
            message: '',
            variant: ''
        })
        setSelectedTopic(prevState => {
            return {
                ...prevState,
                modelId: event.target.value.toString(),
            };
        })
    };

    return (
        <div>
            {topics &&
                <div className="mb-6">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        animate={animate}
                        className="space-y-6"
                    >
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">
                                {level == 0 ? `Topic` : `Subtopic`}
                            </label>
                            <TailwindSelect
                                value={currentTopic ? currentTopic.name : ''}
                                onChange={(value) => {
                                    handleTopicChange({ target: { value } })
                                }}
                                options={topics.map((topic) => ({
                                    value: topic.name,
                                    label: topic.name
                                }))}
                                placeholder={`Select ${level == 0 ? 'topic' : 'subtopic'}`}
                            />
                        </div>
                    </motion.div>
                </div>
            }
            {currentTopic && (currentTopic.models || currentTopic.share_models) && (
                <div className="mb-6">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        animate={animate}
                        className="space-y-6"
                    >
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">
                                Model
                            </label>
                            <TailwindSelect
                                key={currentTopic.name}
                                value={selectedTopic.modelId}
                                onChange={(value) => {
                                    handleModelChange({ target: { value } })
                                }}
                                options={[
                                    ...(currentTopic.models ? currentTopic.models.map((model) => ({
                                        value: model.id.toString(),
                                        label: model.name
                                    })) : []),
                                    ...(currentTopic.shared_models ? currentTopic.shared_models.map((model) => ({
                                        value: model.id.toString(),
                                        label: `${model.name} (Shared)`
                                    })) : [])
                                ]}
                                placeholder="Select model"
                            />
                        </div>
                    </motion.div>
                </div>
            )}
            {currentTopic && currentTopic.subtopics && (currentTopic.models || currentTopic.shared_models ? selectedTopic.modelId !== '' : true) && (
                
                <RecursiveTopicSelector
                key={currentTopic.name}
                topics={currentTopic.subtopics}
                level={level + 1}
                setSelectedTopic={setSelectedTopic}
                selectedTopic={selectedTopic}
                setDisplayError={setDisplayError}
                reset={reset}
                />
            )}
            {
                currentTopic && !currentTopic.subtopics && (
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Description
                        </label>
                        <textarea
                            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-vertical"
                            rows={5}
                            value={selectedTopic.description}
                            onChange={(e) => {
                                handleTopicDescription(e)
                            }}
                        />
                    </div>
                )
            }
        </div>
    );
};

export default RecursiveTopicSelector;
